import IsServerSideRendering from './IsServerSideRendering';

// this function is a lie, fix me pls.  This is for NGC only.  IF YOU THINK IT DOES WHAT YOU WANT YOU ARE WRONG
const isPhoneOrTablet = () => {
  if (IsServerSideRendering) return false;

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return /Android|iPhone|webOS|iPod|Blackberry|Windows Phone|PlayBook/i.test(userAgent);
};

export default isPhoneOrTablet;
